import {UserType} from './constants';
import {userRuleDefaults} from './defaults';
import {UserRule} from './types';

type GetUserRuleParams<
	T extends UserType = typeof userRuleDefaults.elementSubType1,
> = {
	type?: T;
	userId: number;
};

export const createUserRule = ({
	type,
	userId,
}: GetUserRuleParams): UserRule => ({
	...userRuleDefaults,
	elementSubType1: type != null ? type : userRuleDefaults.elementSubType1,
	elementValue1: userId,
});

export default createUserRule;
